import { render, staticRenderFns } from "./AccesosPsp.vue?vue&type=template&id=73561fc6"
import script from "./AccesosPsp.vue?vue&type=script&lang=js"
export * from "./AccesosPsp.vue?vue&type=script&lang=js"
import style0 from "./AccesosPsp.vue?vue&type=style&index=0&id=73561fc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports